<div class="ui-showcase">
  <h1>UI Components Showcase</h1>

  <section class="showcase-section">
    <h2>Text Input Field</h2>
    <div class="showcase-item">
      <h3>Default</h3>
      <input-field label="Name" [control]="textControl"></input-field>
    </div>
    <div class="showcase-item">
      <h3>With prefix icon</h3>
      <input-field label="Search" [control]="textControl" prefixIcon="pi-search"></input-field>
    </div>
    <div class="showcase-item">
      <h3>With English flag prefix</h3>
      <input-field label="English value" [control]="textControl" prefixIcon="en"></input-field>
    </div>
    <div class="showcase-item">
      <h3>With Norwegian flag prefix</h3>
      <input-field label="Norwegian value" [control]="textControl" prefixIcon="nb"></input-field>
    </div>
    <div class="showcase-item">
      <h3>Number type</h3>
      <input-field label="Amount" type="number" [control]="numberControl"></input-field>
    </div>
    <div class="showcase-item">
      <h3>With error</h3>
      <input-field label="Required field" [control]="textWithErrorControl" errorMessage="This field is required"></input-field>
    </div>
  </section>

  <section class="showcase-section">
    <h2>Date Input Field</h2>
    <div class="showcase-item">
      <h3>Default</h3>
      <date-input-field label="Start date" [control]="dateControl"></date-input-field>
    </div>
  </section>

  <section class="showcase-section">
    <h2>Select Input Field</h2>
    <div class="showcase-item">
      <h3>Default</h3>
      <select-input-field label="Choose option" [control]="selectControl" [options]="selectOptions"></select-input-field>
    </div>
  </section>

  <section class="showcase-section">
    <h2>Add Button</h2>
    <div class="showcase-item">
      <h3>Default</h3>
      <add-button label="Add item" icon="pi pi-plus" ariaLabel="Add new item" (clicked)="onAddButtonClick()"></add-button>
    </div>
  </section>
</div>
